import React from 'react';
import PropTypes from 'prop-types';
import { SeIcon } from '@se/web-ui-react';
import './searchTextBox.css';

const SearchTextBox = (props) => {
  // const [searchKey, setSearchKey] = useState(null);
  const { type, placeholder, onSearch } = props;
  // const handleSearch = () => {
  //   onSearch(searchKey, 'searchBox')
  // };
  return (
    <>
      <se-form-field option='stacked' block>
        <div className='searchdiv'>
          <input
            data-testid='searchfield'
            className='searchtextbox'
            type={type}
            placeholder={placeholder}
            onChange={(event) => onSearch(event.target.value, 'searchBox')}
          />
          <SeIcon size='small' className='searchicon'>
            action_search_stroke
          </SeIcon>
        </div>
      </se-form-field>
    </>
  );
};

export default SearchTextBox;

SearchTextBox.propTypes = {
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  handleTextboxEvent: PropTypes.func,
  searchText: PropTypes.string,
  handleEvent: PropTypes.func,
};
